module.exports = __webpack_public_path__ + "static/article-image-01-d2db22bab323f736b3420215c77ecb00.jpg";